import { Chip } from "@mantine/core";

export const BaseChip = Chip